import DateFnsUtils from '@date-io/date-fns'
import { Grid, FormControl, NativeSelect } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import CustomInput from '../../components/CustomInput'
import CustomSelect from '../../components/CustomSelect'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useLeadType } from '../../hooks/CompanyConfiguration/useLeadType'
import { useCustomer } from '../../hooks/Features/useCustomer'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { useLead } from '../../hooks/Features/useLeads'
import { ROUTES, formatNumber, isValidUrl } from '../../shared/constants'
import { ProductContext } from '../../context api/Product/ProductContext'
import { useProduct } from '../../hooks/Features/useProduct'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import SearchIcon from '@material-ui/icons/Search'
import Badge from '@material-ui/core/Badge'
import IconButton from '@material-ui/core/IconButton'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import { withStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import CustomCounter from '../../components/CustomCounter'
import InputAdornment from '@material-ui/core/InputAdornment'
import { useCategory } from '../../hooks/Features/useCategory'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import InputLabel from '@material-ui/core/InputLabel'
import { NoDataFound } from '../../components/NoDataFound'
import ProductCard from './ProductCard'
import CustomDialog from '../../components/CustomDialog'
import CustomDatePicker from '../../components/CustomDatePicker'
import CustomButton from '../../components/CustomButton'
import CustomPagination from '../../components/CustomPagination'

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))(Badge)

const useStyles = makeStyles(() => ({
  searchProduct: {
    width: '95%',
    marginTop: '13px',
    '& input': {
      padding: '5px',
    },
  },
  productGrid: {
    padding: '5px',
    // borderBottom: '1px rgba(0,0,0,0.5) solid',
  },
  // evenIndexProduct: {
  //   borderRight: '1px rgba(0,0,0,0.5) solid',
  // },
  oddIndexProduct: {
    // paddingLeft: '50px',
  },
  addButton: {
    backgroundColor: 'black',
    color: 'white',
    textAlign: 'center',
    width: '170px',
    padding: '3px 0',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  dialog: {
    minWidth: '600px',
  },
  button: {
    margin: '20px auto 0px auto',
  },
}))

export default function SelectProduct() {
  const { products } = useContext(ProductContext)
  const { categories } = useContext(CategoryContext)
  const { getAllProducts, paginate, loading } = useProduct()
  const { getAllCategories } = useCategory()
  const [wishList, setWishList] = useState({})
  const [count, setCount] = useState(0)
  const [totalPrice, setTotalPrice] = useState(0)
  const [filteredProducts, setFilteredProducts] = useState(products)
  const [categoryId, setCategoryId] = useState('')
  const history = useHistory()
  const [page, setPage] = React.useState(1)
  const noOfPages = paginate && paginate.totalPage
  const [open, setOpen] = useState(false)
  const [mustProduct, setMustProduct] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  const handleChange = (event, value) => {
    setPage(value)
  }
  const classes = useStyles()

  React.useEffect(() => {
    setFilteredProducts(products)
  }, [products])

  React.useEffect(() => {
    getAllCategories()
    if (localStorage.getItem('leadProducts')) {
      let tempForm = JSON.parse(localStorage.getItem('leadProducts'))
      setWishList(tempForm.wishList)
      setCount(tempForm.count)
      setTotalPrice(tempForm.totalPrice)
    }
  }, [])

  React.useEffect(() => {
    getAllProducts({ categoryId, page, limit: 20, searchQuery })
  }, [categoryId, page, searchQuery])

  const handleSearchFieldChange = (event) => {
    setFilteredProducts(
      products.filter((item) => {
        return item.name.toUpperCase().includes(event.target.value.toUpperCase())
      })
    )
  }

  const handleAdd = (productId, name, productImage, productPrice, color) => {
    let tempObj = {}
    if (wishList[productId]) {
      tempObj = {
        ...wishList[productId],
        quantity: wishList[productId].quantity + 1,
      }
    } else {
      tempObj = {
        quantity: 1,
        productImage,
        productPrice,
        name,
        color,
      }
    }
    setTotalPrice(totalPrice + productPrice)
    setWishList({
      ...wishList,
      [productId]: tempObj,
    })
    setCount(count + 1)

    // setMustProduct(mustItem)
  }

  useEffect(() => {
    if (mustProduct.length > 0) {
      setOpen(true)
    }
  }, [mustProduct.length > 0])

  //console.log('MUSTR ITEM : ', mustProduct)

  const handleSubtract = (productId) => {
    if (wishList[productId]) {
      let tempObj = {
        ...wishList[productId],
        quantity: wishList[productId].quantity - 1,
      }
      setTotalPrice(totalPrice - tempObj.productPrice)
      if (tempObj.quantity <= 0) delete wishList[productId]
      else {
        setWishList({
          ...wishList,
          [productId]: tempObj,
        })
      }
      setCount(count - 1)
    }
  }

  const handleCartClick = () => {
    history.goBack()
    let leadProducts = {
      wishList: wishList,
      count,
      totalPrice,
      flag: 'ADD',
    }
    if (localStorage.getItem('leadProducts')) {
      let tempForm = JSON.parse(localStorage.getItem('leadProducts'))
      if (tempForm.flag) leadProducts.flag = tempForm.flag // if edit, product will be for edit or if add, product for add
    }
    localStorage.setItem('leadProducts', JSON.stringify(leadProducts))
  }

  // //console.log('LEAD PRODUCTS : ', wishList)

  return (
    <Layout heading="Leads" heading2="Select Product" url1={ROUTES.LEADS} none>
      <Grid container lg={12} style={{ marginLeft: '10px' }}>
        <Grid item lg={3}>
          <div style={{ display: 'flex' }}>
            <FormControl>
              <InputLabel shrink htmlFor="category">
                Select Category
              </InputLabel>
              <NativeSelect
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
                inputProps={{
                  name: 'category',
                  id: 'category',
                }}
              >
                <option value="">All</option>
                {categories && categories.map((cate) => <option value={cate._id}>{cate.categoryName}</option>)}
              </NativeSelect>
            </FormControl>
          </div>
        </Grid>

        <Grid item lg={1} />
        <Grid item lg={7}>
          {/* <div className={classes.searchProduct}> */}
          <TextField
            id="room"
            // variant='outlined'
            placeholder="Search the Product"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            className={classes.searchProduct}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            //placeholder="Select the room"
          />
          {/* </div> */}
        </Grid>

        <Grid item lg={1}>
          <IconButton aria-label="cart" onClick={handleCartClick}>
            <StyledBadge badgeContent={count} color="secondary">
              <ShoppingCartIcon />
            </StyledBadge>
          </IconButton>
        </Grid>
      </Grid>
      <br />
      <br />
      <Grid container style={{ margin: '0 10px' }}>
        {loading ? (
          <Loader />
        ) : filteredProducts ? (
          filteredProducts.map((product, index) => {
            return (
              <ProductCard
                product={product}
                index={index}
                filteredProducts={filteredProducts}
                classes={classes}
                handleAdd={handleAdd}
                handleSubtract={handleSubtract}
                wishList={wishList}
                setMustProduct={setMustProduct}
              />
            )
          })
        ) : (
          <Loader />
        )}
        {filteredProducts && filteredProducts.length === 0 && (
          <Grid lg={11} sm={12}>
            <NoDataFound text="No Products Found" />
          </Grid>
        )}
      </Grid>

      <CustomDialog open={open} handleClose={() => setOpen(false)} heading="Choose Product" className={classes.dialog}>
        <Grid container>
          {mustProduct &&
            mustProduct.map((item, index) => (
              <ProductCard product={item} index={index} filteredProducts={mustProduct} classes={classes} handleAdd={handleAdd} handleSubtract={handleSubtract} wishList={wishList} grid={12} />
            ))}
          {/* <div style={{ display: 'flex', justifyContent: 'center' }}> */}
          <CustomButton text="Close" className={classes.button} handleSubmit={() => setOpen(false)} />
          {/* </div> */}
        </Grid>
      </CustomDialog>
      <CustomPagination page={page} setPage={setPage} noOfPages={noOfPages} handleChange={handleChange} />
    </Layout>
  )
}
